// src/components/Common/ReasonModal.jsx
import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button,
} from '@mui/material';

export default function ReasonModal({
    open, onClose, onSubmit, actionLabel = '처리',
}) {
    const [reason, setReason] = useState('');

    /* 모달이 열리면 입력 초기화 */
    useEffect(() => {
        if (open) setReason('');
    }, [open]);

    const handleSubmit = () => {
        if (!reason.trim()) {
            alert('사유를 입력해주세요.');
            return;
        }
        onSubmit(reason);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    /* 모바일(≤600px): 90 % 축소 */
                    '@media (max-width:600px)': {
                        transform: 'scale(0.9)',
                        transformOrigin: 'top left',
                    },
                },
            }}
        >
            <DialogTitle>{actionLabel} 사유 입력</DialogTitle>

            <DialogContent>
                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    placeholder={`${actionLabel} 사유를 입력하세요`}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    sx={{
                        /* 모바일: 글꼴 조금 축소 */
                        '@media (max-width:600px)': { fontSize: '0.85rem' },
                    }}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>취소</Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    sx={{
                        '@media (max-width:600px)': { fontSize: '0.8rem', px: 1.6 },
                    }}
                >
                    {actionLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
